import { render } from "./AddRules.vue?vue&type=template&id=98ac77d6&scoped=true"
import script from "./AddRules.vue?vue&type=script&lang=js"
export * from "./AddRules.vue?vue&type=script&lang=js"

import "./AddRules.vue?vue&type=style&index=0&id=98ac77d6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ac77d6"],['__file',"src/components/billingRuleBook/AddRules.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98ac77d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98ac77d6', __exports__)) {
    console.log('reload')
    api.reload('98ac77d6', __exports__)
  }
  
  module.hot.accept("./AddRules.vue?vue&type=template&id=98ac77d6&scoped=true", () => {
    console.log('re-render')
    api.rerender('98ac77d6', render)
  })

}


export default __exports__